import { Link } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function SitemapPage() {
  const serviceCategories = [
    {
      title: 'Home Services',
      services: [
        { name: 'Roofing Contractors', path: '/roofing-contractors-el-paso', description: 'Professional roof installation, repair & replacement' },
        { name: 'HVAC Contractors', path: '/hvac-contractors-el-paso', description: 'Heating, ventilation & air conditioning services' },
        { name: 'Plumbing Contractors', path: '/plumbing-contractors-el-paso', description: 'Plumbing installation, repair & maintenance' },
        { name: 'Electrical Contractors', path: '/electrical-contractors-el-paso', description: 'Electrical installation & repair services' },
        { name: 'Painting Contractors', path: '/painting-contractors-el-paso', description: 'Interior & exterior painting services' },
        { name: 'Flooring Contractors', path: '/flooring-contractors-el-paso', description: 'Flooring installation & refinishing' },
      ]
    },
    {
      title: 'Remodeling & Construction',
      services: [
        { name: 'Residential Remodeling', path: '/residential-remodeling-contractors-el-paso', description: 'Complete home renovation services' },
        { name: 'Custom Home Builders', path: '/custom-home-builders-el-paso', description: 'Build your dream custom home' },
        { name: 'Custom Homes', path: '/custom-homes-el-paso', description: 'Custom home design and construction' },
        { name: 'Commercial Contractors', path: '/commercial-contractors-el-paso', description: 'Commercial construction & renovation' },
        { name: 'Window & Door Contractors', path: '/window-door-replacement-el-paso', description: 'Window & door installation & replacement' },
        { name: 'Garage Door Services', path: '/garage-door-contractors-el-paso', description: 'Garage door installation & repair' },
      ]
    },
    {
      title: 'Specialty Services',
      services: [
        { name: 'Solar Panel Installers', path: '/solar-contractors-el-paso', description: 'Solar energy system installation' },
        { name: 'Pool Contractors', path: '/swimming-pool-contractors-el-paso', description: 'Swimming pool construction & maintenance' },
        { name: 'Fence Contractors', path: '/fence-contractors-el-paso', description: 'Fence installation & repair' },
        { name: 'Masonry Contractors', path: '/masonry-contractors-el-paso', description: 'Brick, stone & concrete masonry work' },
        { name: 'Fireproofing Contractors', path: '/fireproofing-companies-el-paso', description: 'Fire protection & fireproofing services' },
        { name: 'Handyman Services', path: '/handyman-services-el-paso', description: 'General home repair & maintenance' },
      ]
    },
    {
      title: 'Interior Finishes',
      services: [
        { name: 'Countertop Installers', path: '/granite-quartz-countertops-el-paso', description: 'Granite, quartz & countertop installation' },
        { name: 'Tile Installers', path: '/tile-installers-el-paso', description: 'Tile installation for floors, walls & more' },
        { name: 'Drywall Contractors', path: '/drywall-contractors-el-paso', description: 'Drywall installation & finishing' },
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-teal-600 to-teal-700 pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            El Paso Contractors Sitemap
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Complete directory of all contractor services available in El Paso, Texas
          </p>
        </div>
      </section>

      {/* Sitemap Content */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          {/* Main Pages */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                <i className="ri-home-4-line text-teal-600 text-xl"></i>
              </span>
              Main Pages
            </h2>
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <ul className="grid md:grid-cols-3 gap-4">
                <li>
                  <Link to="/" className="flex items-center gap-2 text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line text-teal-500"></i>
                    <strong>Home</strong> - Find trusted contractors in El Paso
                  </Link>
                </li>
                <li>
                  <Link to="/sitemap" className="flex items-center gap-2 text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line text-teal-500"></i>
                    <strong>Sitemap</strong> - Complete site navigation
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Service Categories */}
          {serviceCategories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                  <i className={`ri-${categoryIndex === 0 ? 'home-gear' : categoryIndex === 1 ? 'building-2' : categoryIndex === 2 ? 'tools' : 'paint-brush'}-line text-teal-600 text-xl`}></i>
                </span>
                {category.title}
              </h2>
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {category.services.map((service, serviceIndex) => (
                    <li key={serviceIndex}>
                      <Link 
                        to={service.path} 
                        className="group block cursor-pointer"
                      >
                        <div className="flex items-start gap-2">
                          <i className="ri-arrow-right-s-line text-teal-500 mt-1 group-hover:translate-x-1 transition-transform"></i>
                          <div>
                            <span className="text-gray-900 font-medium group-hover:text-teal-600 transition-colors">
                              {service.name}
                            </span>
                            <p className="text-sm text-gray-500 mt-1">
                              {service.description}
                            </p>
                          </div>
                        </div>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}

          {/* Contact Info */}
          <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8 text-center">
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Can&apos;t Find What You&apos;re Looking For?
            </h3>
            <p className="text-gray-600 mb-4">
              Contact us and we&apos;ll help you find the right contractor for your project in El Paso, TX.
            </p>
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 px-6 py-3 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
